<ng-container *ngFor="let progress of progressList">
  <nz-progress
    class="flex-1 last:me-0 me-2"
    [nzStrokeColor]="'#122466E3'"
    [nzShowInfo]="false"
    *ngIf="progress.equity >= percent"
    [nzPercent]="progress.value"
  ></nz-progress
></ng-container>
